module.exports = __webpack_public_path__ + "media/images/img_voice_02-d12767b5fa2d546252e48c03cc6dbff4.png";